<button matIconButton type="button" class="close" (click)="close()"><mat-icon>close</mat-icon></button>
<div class="info-popover-box">
  <p>
    {{data.layerInfoTxt|translate}}
  </p>
  <div>
    @if (data.layerInfoUrl) {
      <a class="b-link" target="_blank" href="{{data.layerInfoUrl|translate}}">{{"layerinfo.READ_MORE"|translate}}&nbsp;</a>
      }<br>
      @if (data.layerInfoMetadataUrl) {
        <a class="b-link" target="_blank" href="{{data.layerInfoMetadataUrl|translate}}">{{"layerinfo.METADATA_TXT"|translate}}&nbsp;</a>
      }
    </div>
  </div>